import React, { createRef, useContext, useEffect, useState } from "react";
import SelectField from "../../FormFields/SelectField";
import { useFormikContext } from "formik";
import InputField from "../../FormFields/InputField";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import InputRefField from "../../FormFields/InputRefField";
import MotovehiculoContext from "../../../../context/products/MotovehiculoContext/MotovehiculoContext";
import { findSelectedLabel } from "../../../findSelectedLabel";
import { Grid } from "@mantine/core";
import { ZipCodeFieldPackage } from "../../../ZipCodeFieldPackage";
import CotizarContext from "../../../../context/CotizarContext";

export default function VehiculoForm(props) {
    const {
        formField: {
            vehiculo: {
                marca, anio, version, ceroKm
            },
            cliente: {
                nombre,
                apellido,
                telefono,
                email,
                codigosLocalidad,
                codigoPostal,
                idProvincia
            },
        },
        localidadOptions,
        setLocalidadOptions,
        provinciasOptions,
        setProvinciasOptions
    } = props;
    const { values, setFieldValue } = useFormikContext();
    const ref = createRef();

    const {
        marcas,
        anios,
        versiones,
        vehicleDetails,
        updateVersions,
        isLoadingVersions
    } = useContext(MotovehiculoContext);

    const cerokm_options = [
        { value: 'true', label: 'Si' },
        { value: 'false', label: 'No' }
    ];

    useEffect(() => {
        setFieldValue(`vehiculo.${version.name}`, '', false);
        if (values.vehiculo.anio !== '') {
            updateVersions(values.vehiculo.marca, values.vehiculo.anio);
        }
    }, [values.vehiculo.anio, values.vehiculo.marca]);

    return (
        <React.Fragment>
            <Grid align="center">
                <Grid.Col xs={12} sm={6}>
                    <SelectField
                        name={`vehiculo.${marca.name}`}
                        label={marca.label}
                        data={marcas}
                        withAsterisk
                        onChangeAction={value => {
                            vehicleDetails.current = {
                                ...vehicleDetails.current,
                                detalle_marca: findSelectedLabel(marcas, value)
                            }
                        }}
                    />
                </Grid.Col>

                <Grid.Col xs={12} sm={6}>
                    <SelectField
                        name={`vehiculo.${anio.name}`}
                        label={anio.label}
                        data={anios}
                        withAsterisk
                    />
                </Grid.Col>

                <Grid.Col xs={12} sm={6}>
                    <SelectField
                        name={`vehiculo.${version.name}`}
                        label={version.label}
                        loadingData={isLoadingVersions}
                        data={versiones}
                        withAsterisk
                        onChangeAction={value => {
                            vehicleDetails.current = {
                                ...vehicleDetails.current,
                                detalle_version: findSelectedLabel(versiones, value)
                            }
                        }}
                        clearable
                    />
                </Grid.Col>

                <Grid.Col xs={12} sm={6}>
                    <SelectField
                        name={`vehiculo.${ceroKm.name}`}
                        label={ceroKm.label}
                        data={cerokm_options}
                        withAsterisk
                    />
                    {values.vehiculo.tieneGnc === 'true' && (
                        <div className="fill__div" />
                    )}
                </Grid.Col>

                <ZipCodeFieldPackage
                    localidadField={codigosLocalidad}
                    localidadSize={6}
                    codigoPostalField={codigoPostal}
                    codigoPostalSize={6}
                    provinciaField={idProvincia}
                    provinciaSize={6}
                    localidadOptions={localidadOptions}
                    setLocalidadOptions={setLocalidadOptions}
                    provinciasOptions={provinciasOptions}
                    setProvinciaOptions={setProvinciasOptions} />

                <Grid.Col xs={12} sm={6}>
                    <InputField
                        name={`cliente.${nombre.name}`}
                        label={nombre.label}
                        withAsterisk
                    />
                </Grid.Col>

                <Grid.Col xs={12} sm={6}>
                    <InputField
                        name={`cliente.${apellido.name}`}
                        label={apellido.label}
                        withAsterisk
                    />
                </Grid.Col>

                <Grid.Col xs={12} sm={6}>
                    <div className="field">
                        <PhoneInput
                            defaultCountry="AR"
                            ref={ref}
                            inputComponent={InputRefField}
                            name={`cliente.${telefono.name}`}
                            label={telefono.label}
                            withAsterisk
                            value={values.cliente.telefono}
                            onChange={(e) => {
                                setFieldValue(`cliente.${telefono.name}`, e)
                            }}
                        />
                    </div>
                </Grid.Col>

                <Grid.Col xs={12} sm={6}>
                    <InputField
                        name={`cliente.${email.name}`}
                        label={email.label}
                        withAsterisk
                    />
                </Grid.Col>
            </Grid>
        </React.Fragment>
    );
}
